export default {
  QuoteBooking: 'QuoteBooking',
  Repair: 'Repair',
  Repx: 'Repx'
}